/**
 * RouteNotFound — the app's catch-all route.
 *
 * Sidebar links come live from auth.page_config, but routes are compiled into
 * the JavaScript bundle. A tab opened before a deploy keeps running the old
 * bundle, so a newly added page (e.g. /dto/software on 2026-10-24) shows in the
 * nav but has no route. The old catch-all silently sent the user to the home
 * menu, which looked like the page was broken.
 *
 * Now: reload once to fetch the current bundle (remembered per path in
 * sessionStorage so it can never loop). If the path is still unknown after
 * that, say so instead of pretending.
 */

import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const RouteNotFound = () => {
  const { pathname } = useLocation();
  const key = `route-reload:${pathname}`;
  let alreadyReloaded = false;
  try { alreadyReloaded = sessionStorage.getItem(key) === '1'; } catch (_) { alreadyReloaded = true; }

  useEffect(() => {
    if (alreadyReloaded) return;
    try { sessionStorage.setItem(key, '1'); } catch (_) { return; }
    window.location.reload();
  }, [alreadyReloaded, key]);

  if (!alreadyReloaded) return <div className="p-6 text-gray-600">Loading the latest version…</div>;

  return (
    <div className="p-6 max-w-xl mx-auto text-center">
      <h1 className="text-xl font-semibold text-gray-900 mb-2">Page not found</h1>
      <p className="text-gray-600 mb-4">
        There is no page at <code>{pathname}</code>. If a menu link brought you here, the page may be listed in
        Domain Configuration without being built yet.
      </p>
      <Link to="/" className="text-blue-700 hover:underline">Back to the home menu</Link>
    </div>
  );
};

export default RouteNotFound;
